"use strict";var D=Object.create;var b=Object.defineProperty;var q=Object.getOwnPropertyDescriptor;var I=Object.getOwnPropertyNames;var J=Object.getPrototypeOf,_=Object.prototype.hasOwnProperty;var o=(r,e)=>b(r,"name",{value:e,configurable:!0});var j=(r,e)=>{for(var t in e)b(r,t,{get:e[t],enumerable:!0})},v=(r,e,t,i)=>{if(e&&typeof e=="object"||typeof e=="function")for(let s of I(e))!_.call(r,s)&&s!==t&&b(r,s,{get:()=>e[s],enumerable:!(i=q(e,s))||i.enumerable});return r};var f=(r,e,t)=>(t=r!=null?D(J(r)):{},v(e||!r||!r.__esModule?b(t,"default",{value:r,enumerable:!0}):t,r)),H=r=>v(b({},"__esModule",{value:!0}),r);var G={};j(G,{NProvider:()=>X,Next13ProgressBar:()=>A,useNProgress:()=>w,useRouter:()=>U});module.exports=H(G);var m=f(require("react"));var a=f(require("nprogress")),n=f(require("prop-types")),d=f(require("react"));var S=o(({color:r="#29D",startPosition:e=.3,height:t=3,options:i,nonce:s,transformCSS:P=o(p=>d.createElement("style",{nonce:s},p),"transformCSS")})=>(d.useEffect(()=>(a.configure({...i}),a.set(e),a.start(),a.inc(),()=>{a.done()}),[]),P(`
    #nprogress {
      pointer-events: none;
    }
    #nprogress .bar {
      background: ${r};
      position: fixed;
      z-index: 9999;
      top: 0;
      left: 0;
      width: 100%;
      height: ${t}px;
    }
    #nprogress .peg {
      display: block;
      position: absolute;
      right: 0px;
      width: 100px;
      height: 100%;
      box-shadow: 0 0 10px ${r}, 0 0 5px ${r};
      opacity: 1;
      -webkit-transform: rotate(3deg) translate(0px, -4px);
      -ms-transform: rotate(3deg) translate(0px, -4px);
      transform: rotate(3deg) translate(0px, -4px);
    }
    #nprogress .spinner {
      display: block;
      position: fixed;
      z-index: 1031;
      top: 15px;
      right: 15px;
    }
    #nprogress .spinner-icon {
      width: 18px;
      height: 18px;
      box-sizing: border-box;
      border: solid 2px transparent;
      border-top-color: ${r};
      border-left-color: ${r};
      border-radius: 50%;
      -webkit-animation: nprogresss-spinner 400ms linear infinite;
      animation: nprogress-spinner 400ms linear infinite;
    }
    .nprogress-custom-parent {
      overflow: hidden;
      position: relative;
    }
    .nprogress-custom-parent #nprogress .spinner,
    .nprogress-custom-parent #nprogress .bar {
      position: absolute;
    }
    @-webkit-keyframes nprogress-spinner {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
    @keyframes nprogress-spinner {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `)),"Next13Progress");S.propTypes={color:n.string,startPosition:n.number,stopDelayMs:n.number,height:n.number,showOnShallow:n.bool,options:n.object,nonce:n.string,transformCSS:n.func};var E=d.memo(S);var T=require("react"),R=require("next/navigation");function $(){let r=(0,R.usePathname)(),{setShowProgressBar:e}=w();return(0,T.useEffect)(()=>{e(!1)},[r]),null}o($,"NavigationEvents");var B=require("next/navigation");var L=m.default.createContext({showProgressBar:!1,setShowProgressBar:()=>{}}),X=o(r=>{let[e,t]=m.default.useState(!1),i=(0,B.usePathname)();(0,m.useEffect)(()=>{document.querySelectorAll("a").forEach(p=>{p.addEventListener("click",y=>{p.target!=="_blank"&&(p.onclick&&p.onclick(y),i!==p.href&&t(!0))})})},[]);let s={...r};return delete s.children,m.default.createElement(L.Provider,{value:{showProgressBar:e,setShowProgressBar:t}},e&&m.default.createElement(E,{...r}),m.default.createElement($,null),r.children)},"NProvider"),w=o(()=>m.default.useContext(L),"useNProgress");var x=f(require("react")),h=f(require("nprogress")),u=require("next/navigation");var A=x.default.memo(({color:r="#0A2FFF",height:e="2px",options:t,showOnShallow:i=!1,delay:s=0,style:P})=>{let p=x.default.createElement("style",null,P||`
          #nprogress {
            pointer-events: none;
          }
          
          #nprogress .bar {
            background: ${r};
          
            position: fixed;
            z-index: 1031;
            top: 0;
            left: 0;
          
            width: 100%;
            height: ${e};
          }
          
          /* Fancy blur effect */
          #nprogress .peg {
            display: block;
            position: absolute;
            right: 0px;
            width: 100px;
            height: 100%;
            box-shadow: 0 0 10px ${r}, 0 0 5px ${r};
            opacity: 1.0;
          
            -webkit-transform: rotate(3deg) translate(0px, -4px);
                -ms-transform: rotate(3deg) translate(0px, -4px);
                    transform: rotate(3deg) translate(0px, -4px);
          }
          
          /* Remove these to get rid of the spinner */
          #nprogress .spinner {
            display: block;
            position: fixed;
            z-index: 1031;
            top: 15px;
            right: 15px;
          }
          
          #nprogress .spinner-icon {
            width: 18px;
            height: 18px;
            box-sizing: border-box;
          
            border: solid 2px transparent;
            border-top-color: ${r};
            border-left-color: ${r};
            border-radius: 50%;
          
            -webkit-animation: nprogress-spinner 400ms linear infinite;
                    animation: nprogress-spinner 400ms linear infinite;
          }
          
          .nprogress-custom-parent {
            overflow: hidden;
            position: relative;
          }
          
          .nprogress-custom-parent #nprogress .spinner,
          .nprogress-custom-parent #nprogress .bar {
            position: absolute;
          }
          
          @-webkit-keyframes nprogress-spinner {
            0%   { -webkit-transform: rotate(0deg); }
            100% { -webkit-transform: rotate(360deg); }
          }
          @keyframes nprogress-spinner {
            0%   { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `);h.default.configure(t||{});let y=(0,u.usePathname)(),C=(0,u.useSearchParams)();return(0,x.useEffect)(()=>{h.default.done()},[y,C]),(0,x.useEffect)(()=>{let N,O=o(()=>{N=setTimeout(h.default.start,s)},"startProgress"),M=o(()=>{clearTimeout(N),h.default.done()},"stopProgress"),z=o(g=>{let c=g.currentTarget;if(c.target==="_blank"||c.hasAttribute("download"))return;let l=new URL(c.href),K=new URL(location.href),k=l?.pathname===K?.pathname;g.metaKey||g.ctrlKey||g.shiftKey||g.altKey||i&&k||k||O()},"handleAnchorClick"),F=o(()=>{let g=document.querySelectorAll("a");Array.from(g).filter(l=>l.href).forEach(l=>l.addEventListener("click",z))},"handleMutation");new MutationObserver(F).observe(document,{childList:!0,subtree:!0}),window.history.pushState=new Proxy(window.history.pushState,{apply:(g,c,l)=>(M(),g.apply(c,l))})},[]),p},()=>!0);function U(){let r=(0,u.useRouter)(),e=(0,u.usePathname)();function t(i,s){return new URL(i,location.href).pathname===e?Promise.resolve(!0):(h.default.start(),r.push(i,s))}return o(t,"push"),{...r,push:t}}o(U,"useRouter");0&&(module.exports={NProvider,Next13ProgressBar,useNProgress,useRouter});
//# sourceMappingURL=index.js.map